import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import SignUpForm from '../components/auth/SignUpForm';
import Layout from '../components/layout/Layout';
import { useAuth } from '../hooks/useAuth';

const SignUp: React.FC = () => {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect if user is already signed in
  useEffect(() => {
    if (currentUser && !loading) {
      navigate('/my-wheels');
    }
  }, [currentUser, loading, navigate]);

  // Handle successful sign up
  const handleSuccess = () => {
    // We don't navigate immediately after sign up because the user needs to verify their email
    // Instead, we show a success message in the form
  };

  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-md mx-auto bg-white rounded-xl shadow-md overflow-hidden p-8">
          <SignUpForm onSuccess={handleSuccess} />
        </div>
      </div>
    </Layout>
  );
};

export default SignUp;
